import { type MonthAbbreviation } from './types';

export const THAI_MONTH_NAMES: Record<MonthAbbreviation, string> = {
  JAN: 'มกราคม',
  FEB: 'กุมภาพันธ์',
  MAR: 'มีนาคม',
  APR: 'เมษายน',
  MAY: 'พฤษภาคม',
  JUN: 'มิถุนายน',
  JUL: 'กรกฎาคม',
  AUG: 'สิงหาคม',
  SEP: 'กันยายน',
  OCT: 'ตุลาคม',
  NOV: 'พฤศจิกายน',
  DEC: 'ธันวาคม',
};

export const MONTH_ORDER = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
] as const;

export const MONTH_OPTIONS = MONTH_ORDER.map((monthAbbr) => ({
  label: THAI_MONTH_NAMES[monthAbbr],
  value: monthAbbr,
}));

//TODO: Update this constant when migrating data from the old system
export const STARTING_YEAR = 2025;
